import { useEffect, useMemo, useState } from 'react';
import { Cascader, CascaderAutoProps, Form, FormItemProps } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';

import { DefaultOptionType } from 'antd/es/select';
import { useCategory } from '../../../store/category_example';
import { categoryById as categoryByIdAction,
  categoryByIdClear as categoryByIdClearAction } from '../../../store/category_example/byId';
import { categoryListAll as categoryListAllAction,
  categoryListAllClear as categoryListAllClearAction } from '../../../store/category_example/listAll';

interface SelectCategoryProps {
  categoryListAll: typeof categoryListAllAction;
  categoryListAllClear: typeof categoryListAllClearAction;
  categoryById: typeof categoryByIdAction;
  categoryByIdClear: typeof categoryByIdClearAction;
  defaultCategoryId?: string | null;

  formItemProps?: FormItemProps;
  selectProps?: CascaderAutoProps<DefaultOptionType>;
}

function SelectCategory({
  categoryListAll,
  categoryListAllClear,
  categoryById,
  categoryByIdClear,
  defaultCategoryId,
  formItemProps,
  selectProps,
}: SelectCategoryProps) {
  const { listAll, byId } = useCategory();
  const [search, setSearch] = useState('');

  const options: DefaultOptionType[] = useMemo(() => {
    const optionsFromList: DefaultOptionType[] = listAll.response?.data.map(
      ({ id, name, subCategories }): DefaultOptionType => ({
        label: name,
        value: id,
        // eslint-disable-next-line @typescript-eslint/no-shadow
        children: subCategories.map(({ id, header }) => ({ label: header, value: id })),
      }),
    ) || [];

    if (
      !search
      && defaultCategoryId
      && byId.response
      && !listAll.response?.data.some(({ id }) => id === defaultCategoryId)
    ) {
      optionsFromList.unshift({
        label: byId.response.name,
        value: byId.response.id,
        children: byId.response.subCategories.map(({ id, header }) => ({ label: header, value: id })),
      });
    }

    return [
      {
        label: 'Worker',
        value: null,
        children: [
          {
            label: 'Non-tipped Worker',
            value: null,
          },
        ],
      },
      ...optionsFromList,
    ];
  }, [listAll.response?.data, byId.response]);

  useEffect(() => {
    // eslint-disable-next-line max-len
    if (defaultCategoryId && listAll.response?.data && !byId.response && !listAll.response.data.some(({ id }) => id === defaultCategoryId)) {
      categoryById({ id: defaultCategoryId });
    }
  }, [listAll.response?.data, defaultCategoryId]);

  useEffect(
    () => () => {
      categoryListAllClear();
      categoryByIdClear();
    },
    [],
  );

  useEffect(() => {
    categoryListAll({ page: 1, pageSize: 500, search });
  }, [search]);

  return (
    <Form.Item label="Industry" name="categoryAndSubCategoryIds" {...formItemProps}>
      <Cascader
        placeholder="Industry"
        options={options}
        onSearch={setSearch}
        showSearch
        allowClear
        changeOnSelect
        dropdownMatchSelectWidth={false}
        loading={listAll.loading || byId.loading}
        loadingIcon={<LoadingOutlined />}
        {...selectProps}
      />
    </Form.Item>
  );
}

export default connect(() => ({}), {
  categoryListAll: categoryListAllAction,
  categoryListAllClear: categoryListAllClearAction,
  categoryById: categoryByIdAction,
  categoryByIdClear: categoryByIdClearAction,
})(SelectCategory);
